import Dashboard from "./main/Dashboard/dashboard";
import SubmissionList from "./main/Submission/submissionList";
import SubmissionDetail from "./main/WellskyPatient/patientDetail";
import ManageSubmission from "./main/Submission/manageSubmission";
import PatientList from "./main/WellskyPatient/patientList";
import PatientDetail from "./main/WellskyPatient/patientDetail";
import StateAndCityList from "./main/StateAndCity/StateAndCityList";
import UsersList from "./main/Users/UsersList";
import MarketersList from "./main/Marketers/MarketersList";
import ProfilePage from "./main/Account/ProfilePage";
import ChangePasswordPage from "./main/Account/ChangePasswordPage";

const RouteComponentMap = {
  Dashboard,
  SubmissionList,
  SubmissionDetail,
  ManageSubmission,
  PatientList,
  PatientDetail,
  StateAndCityList,
  UsersList,
  MarketersList,
  ProfilePage,
  ChangePasswordPage,
};

export default RouteComponentMap;
